module.exports = __webpack_public_path__ + "static/media/nav-link-arrow-line.784d9783.svg";